<template>
  <exo-help-dialog
    width="1000"
    margin="m-0 ml-1 justify-center"
    title="Processes"
  >
    <h5>Presentation</h5>
    When starting the computation of a mission, it is considered as a running
    process.
    <br />
    If you start another computation and no runners are available, it is
    considered a pending process.
    <br />
    You can see how many processes can be run by checking the
    <em>Number of process runners available</em>.
    <br />
    You can also see how long the pending list is by checking the
    <em>Total queue list</em>.
    <br />
    The process page is here to let you keep an eye on all the processes that
    are running and pending.
    <br />
    <br />
    <h5>Technical notes</h5>
    When cancelling a running process, the first process from the pending list
    will be run.
    <br />
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipProcesses'
}
</script>
